import { request, request2 } from "../utils/request";

const forgetpassword = {
  //获取guidcode
  getguidCode() {
    return request({
      method: "GET",
      url: "/api/user/register/getguidCode"
    });
  },
  //获取图片验证码
  CreateVerificationCode(data) {
    //https://blog.csdn.net/qq_39600914/article/details/100632703
    return request2({
      method: "GET",
      url: `/VerificationCode/CreateVerificationCode?${data}`,
      responseType: "arraybuffer"
    });
  },

  checkPhoneAndVerifyCode(data) {
    //检查手机号和验证码
    return request({
      method: "POST",
      url: "/api/user/findpwd/checkPhoneAndVerifyCode",
      data
    });
    /*
VerifyCode	string	
验证码

guidCode	string	
认证码

phone	String	
手机号 */
  },
  sendMsg(data) {
    //发送短信验证码
    return request({
      method: "POST",
      url: "/api/user/findpwd/sendMsg",
      data
    });
    /*
guid	string	
唯一标识符

phone	string	
手机号 */
  },
  checkMsg(data) {
    //校验短信验证码
    return request({
      method: "POST",
      url: "/api/user/findpwd/checkMsg",
      data
    });
  },
  updatePwd(data) {
    return request({
      method: "POST",
      url: "/api/user/findpwd/updatePwd",
      data
    });
  },
  // 验证旧密码修改
  modifyPwd(data) {
    return request({
      method: "POST",
      url: "/api/user/pwdManager/modifyPwd",
      data
    });
  }
};

export default forgetpassword;
